import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/manipulation/remove/remove.js";
import "dabbyjs/src/traversal/eq/eq.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/dimensions/position/position.js";
import "dabbyjs/src/attributes/attr/attr.js";

export default (obj, msg) => {
	if (obj.length) {

		// remove error message
		$(".msg--error", obj).remove();

		// add new message
		if (msg) {
			$(".hashform__item-heading", obj).eq(0).after($("<div>", {"class": "msg msg--error", text: msg}));
			window.scroll({
				top: obj.position().top,
				behavior: "smooth" // Optional for smooth scrolling
			});
		}
	}
};